// extracted by mini-css-extract-plugin
export default {"accordionHeader":"accordion_header-module___accordionHeader___f14d8f19","buttons":"accordion_header-module___buttons___c038d2f7"};